import {
    StyleSheet
} from "react-native";
import {
    webStyle
} from "ncore-ui-kit";

const stylesheet = StyleSheet.create({
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap",
        width: "100%"
    },
    cardBody: {
        justifyContent: "space-between",
        display: "flex",
        width: "100%",
        flex: 1
    },
    cardContainer: {
        flexDirection: "column",
        overflow: "hidden",
        display: "flex",
        width: "100%",
        flex: 1,
        ...webStyle({
            transition: "all 0.2s ease"
        })
    },
    cardBanner: {
        justifyContent: "flex-start",
        alignItems: "flex-end",
        position: "relative",
        aspectRatio: 4 / 5,
        width: "100%"
    },
    gridContainer: {
        justifyContent: "flex-start",
        flexDirection: "row",
        flexWrap: "wrap",
        width: "100%"
    },
    emptyContainer: {
        justifyContent: "center",
        alignItems: "center",
        width: "100%"
    },
    avatarBadge: {
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        height: 44,
        width: 44
    },
    cardWrapper: {
        flexDirection: "column",
        display: "flex",
        flexBasis: 320,
        flexShrink: 1,
        flexGrow: 0
    },
    filterSection: {
        alignItems: "flex-end",
        flexDirection: "row",
        flexWrap: "wrap",
        width: "100%"
    },
    memberBadge: {
        alignSelf: "flex-start"
    },
    filterDropdownContainer: {
        minWidth: 200
    },
    cardBadgeContainer: {
        position: "absolute",
        bottom: -22,
        zIndex: 10,
        left: 16
    },
    memberBadgeRow: {
        alignItems: "center",
        flexDirection: "row",
        minHeight: 28
    },
    cardTypeBadge: {
        position: "absolute",
        right: 12,
        top: 12
    },
    bannerImage: {
        position: "absolute",
        height: "100%",
        width: "100%",
        left: 0,
        top: 0
    },
    avatarBadgeText: {
        textAlign: "center",
        fontWeight: "700"
    },
    emptyText: {
        textAlign: "center"
    },
    cardTitle: {
        fontWeight: "700"
    },
    searchContainer: {
        minWidth: 250,
        flex: 1
    },
    cardDescription: {
        width: "100%"
    },
    container: {
        width: "100%",
        flex: 1
    },
    cardContentTop: {
        width: "100%"
    },
    cardFooter: {
        width: "100%"
    }
});

export default stylesheet;
